import {CartHelper} from "~/helpers/CartHelper";
import {CartItem} from "~/dto/CartItem";
import type {CartItemInterface} from "~/interfaces/CartItemInterface";

export class Cart {


    items: Array<CartItem> = [];
    // Промокод / код партнёра на всю корзину. Ставится при добавлении товара
    // (переход по партнёрской ссылке) либо над корзиной при оформлении.
    partnerCode: string | null = null;

    static createFromArray(items: Array<CartItemInterface>, partnerCode: string | null = null) {
        const cart = new Cart();
        cart.items = items.map(el => CartItem.createFromObj(el));
        cart.partnerCode = partnerCode || null;
        return cart;
    }

    setPartnerCode(code: string | null): void {
        this.partnerCode = code && code.trim() !== "" ? code.trim() : null;
        CartHelper.saveCart();
    }

    addProduct(
        id: number,
        variantId: null | number,
        count: number = 1,
        itemId: number | null = null,
        attributeLabel: string | null = null,
        attributeValue: string | null = null,
        vibeId: number | null = null
    ) {
        if (!variantId) variantId = id;
        let item = this.findProduct(id, variantId, itemId, vibeId);
        if (!item) {
            item = new CartItem(id, variantId, itemId, vibeId);
            item.count = count;
            item.attributeLabel = attributeLabel;
            item.attributeValue = attributeValue;
            this.items.push(item);
        } else {
            item.count += count;
        }
        CartHelper.saveCart();
    }

    /**
     * Уникальность позиции — id + variantId (цвет, старая self-join модель)
     * + itemId (размер, SKU) + vibeId (вайб, с которого положили). Один и тот
     * же товар в разных размерах или с разных вайбов — разные позиции.
     */
    findProduct(
        id: number,
        variantId: null | number,
        itemId: number | null = null,
        vibeId: number | null = null
    ): CartItem | undefined {
        if (!variantId) variantId = id;
        return this.items.find(el =>
            el.id === id
            && el.variantId === variantId
            && (el.itemId ?? null) === (itemId ?? null)
            && (el.vibeId ?? null) === (vibeId ?? null)
        );
    }

    /**
     * itemId/vibeId matter here for the same reason as findProduct: a product
     * with no color variants has variantId === id for every one of its sizes,
     * so matching on variantId alone would delete whichever same-product row
     * happens to come first instead of the specific line being removed.
     */
    deleteProduct(variantId: number, itemId: number | null = null, vibeId: number | null = null): void {
        const i = this.items.findIndex(el =>
            el.variantId === variantId
            && (el.itemId ?? null) === (itemId ?? null)
            && (el.vibeId ?? null) === (vibeId ?? null)
        );
        if (~i) {
            this.items.splice(i, 1);
            CartHelper.saveCart();
        }
    }

    public clear() {
        this.items = [];
        this.partnerCode = null;
        CartHelper.saveCart();
    }

    hasItems(): boolean {
        return this.items.length > 0;
    }

    toArray(): Array<Object> {
        return this.items.map(el => el.toObj());
    }

}
